export const INITIAL_EXTRAORDINARY_INFORMATIONS_STATE = {};
